/* eslint-disable */
<template>
    <div class="ma-0 pa-0">
        <BasicCard :show_title="false">
            <div>
                <v-container>
                    <v-row no-gutters>
                           <v-col cols="4" md="4" class="d-flex justify-start align-content-center">
                            <v-autocomplete dense outlined
                                    label="famiglia"
                                    v-model="filter.search_family"
                                    :items="families"
                                    clearable
                                ></v-autocomplete>
                        </v-col>
                        <v-col cols="8" class="d-flex justify-end align-content-center pl-2">
                            <v-btn color="primary" class="text-center" @click="updateSearch"><v-icon class="ma-2">search</v-icon>cerca</v-btn>
                            <v-btn color="action" class="text-center ml-2" @click="resetSearch">annulla</v-btn>
                        </v-col>
                        <!--v-col cols="2" class="d-flex justify-end align-content-center">
                            <v-btn
                                color="action"
                                @click.stop="openFilter"
                                ><v-icon>filter_list</v-icon>Filtra</v-btn>
                        </v-col-->
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center mt-4">
                            <span><v-autocomplete dense outlined
                                    label="ordina per"
                                    v-model="sort_fields"
                                    :items="sorting_fields"
                                    item-value="value"
                                    item-text="label"
                                    return-object
                                    @change="changeOrder"
                                ></v-autocomplete>
                            </span>
                            <span>
                                <v-btn v-if="enable_ops" color="action" class="ml-2" @click.stop="newOperation"><v-icon small class="pr-1">add_box</v-icon>nuovo intervento</v-btn>
                                <v-btn color="action" class="ml-2" @click.stop="editInstrument(null)"><v-icon small class="pr-1">add_box</v-icon>strumento</v-btn>
                            </span>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
            <div v-if="!searching">
                <v-data-table
                    :items="objects"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    dense
                    hide-default-header
                    hide-default-footer
                    @page-count="pageCount = $event">
                    <template v-slot:body="{ items }">
                    <tbody >
                        <div v-if="objects.length == 0" class="px-2 text-h6 text-center">
                            Nessuno strumento trovato
                        </div>
                        <tr class="pa-0 ma-0" v-for="instr in items" :key="instr._id">
                            <td>
                                <InstrumentItem 
                                    :instrument_id="instr._id"
                                    :show_location="true"
                                    :show_platform_capacity="true"
                                    :can_change="false">
                                    <template v-slot:other_action>
                                        <v-btn color="primary" @click.stop="openDelete(instr)" fab small><v-icon class="pa-2">delete</v-icon></v-btn>
                                    </template>
                                </InstrumentItem>
                            </td>
                        </tr>
                    </tbody>
                    </template>
                </v-data-table>
                <div v-if="objects.length > 0" class="text-center pa-2">
                    <div class="text-right font-italic font-small">Totale: {{ this.objects.length }}</div>
                    <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" :total-visible="7"></v-pagination>
                </div>
            </div>
            <div v-else>
                <v-card-text class="xs12 text-center">
                    <v-progress-circular
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                    ></v-progress-circular>
                </v-card-text>
            </div>
        </BasicCard>
        <ConfirmDialog
            v-bind:data="delete_confirm"
            v-on:close_dialog="closeDialog"
            v-on:confirm_result="onDeleteConfirm"/>
        
    </div>
</template>

<script>
// import _ from 'lodash'
import BasicCard from "../../components/utils/Basic_card"
import ConfirmDialog from "../../components/dialogs/ConfirmDialog"
import InstrumentItem from "./InstrumentItem"
import {ListManagement} from "../../utils/listMixin"
import {i_families} from "../../utils/common.js"
import { formatDatefromTS } from '../../utils/commonUtils'

export default {
    components: {BasicCard, InstrumentItem, ConfirmDialog},
    mixins: [ListManagement],
    props: {
        'client_id': {
            type: String,
            required: false,
            default: null
        }
    },
    data(){
        return {
            families: Object.keys(i_families),
            data:  {},
            db: 'registry',
            org_id: null,
            sort_asc: true,
            filter: {
                search_family: "",
            },
            searching: true,
            sorting_fields: [
                {label: 'scadenza', value: ['value.exp', 'value.name', 'value.serno'], order: ['asc', 'asc']},
                {label: 'modifica', value:['value.updated', 'value.name', 'value.serno'], order: ['desc', 'asc']},
                {label: 'nome/codice cliente', value: ['value.name', 'value.serno', 'value.exp'], order: ['asc', 'asc']},
                {label: 'seriale', value: ['value.serno', 'value.name', 'value.exp'], order: ['asc', 'asc']},
                {label: 'famiglia', value: ['value.family', 'value.exp', 'value.name'], order: ['asc', 'asc']}
            ],
            sort_fields: {},
            page: 1,
            itemsPerPage: 10,
            pageCount: 0,
            list_type: 'instrument'
        }
    },
    async beforeMount() {
        //this.changeSelector()
        this.sort_fields = this.sorting_fields[0]
        let filter = this.restore_history_params()
        if (this.client_id) {
            this.filter.client_id = this.client_id
        }
        this.updateSearch()
    },
    methods: {
        formatDate(ts) {
            return formatDatefromTS(ts)
        },
        resetSearch(){
            this.filter = {
                search_family: "",
            }
            //this.updateSearch()
            this.$store.commit('setSearchParam', {path: this.$router.history.current.fullPath, filter: null, page:1, sort_fields: this.sorting_fields[0]})
        },
        async updateSearch() {
            this.searching = true
            var selectors = ['instrument']
            if (this.filter.search_family){
                selectors.push(['client', this.filter.client_id])
            }
            if (this.filter.search_family){
                selectors.push(['family', this.filter.search_family])
            }
            let res = await this.searchFromDesignNew('instruments/searchByDismissed', 'all_keys', selectors, false)
            this.objects = this.orderBy(res, this.sort_fields)
            
            this.searching = false
        },
        async refreshInstrument() {
            // this.sort_fields = this.sorting_fields[0]
            await this.updateSearch()
        },
        openDeleteInstrumentConfirm(){
            console.log('DELETE')
            this.delete_confirm.message = "Sei sicuro di voler cancellare definitivamente <br/><b>" + this.instrument.name+" / "+ this.instrument.serno+" - "+this.instrument.manufacturer+" - "+this.instrument.model+"</b>?"
            this.delete_confirm.dialog = true;
        },
        async onDeleteConfirm(choice){
            try {
                if(choice == "delete"){
                    this.instrument.updated_by = this.$store.state.user._id
                    this.instrument.updated = (new Date()).getTime()
                    this.instrument._deleted = true
                    let res = await this.$store.state.$pouch.put('registry', this.instrument)
                    if (res.ok) {
                        this.instrument._rev = res.rev
                        this.$emit('remove_instrument', this.instrument._id)
                    }
                }
                this.refreshInstrument()
                this.closeDialog()
            } catch(error) {
                console.log('error', error)
            }
        },
        closeDialog(){
            this.delete_confirm.dialog = false;
        },
    }
}
</script>

<style>

</style>
